// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saltCalendarMonth-dateGrid{gap:var(--salt-size-border);grid-template-columns:repeat(7, var(--salt-size-base));grid-template-rows:repeat(6, var(--salt-size-base));text-align:center;margin:var(--salt-size-border);display:grid}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
